skrilla.directive('queryPickemsContests', function () {
  return {
    templateUrl: 'directives/pickems/queryContests/queryContests.html',
    scope: {
      contests: "=",
      userId: "="
    },
    controller: async function ($scope, searchService, queryService, paginationService, cacheService, sportService) {
      $scope.pageKey = "contests";
      $scope.queryKey = "queryPickemsContest";
      $scope.reset = function () {
        $scope.query = {
          limit: 20,

          statuses: {
            PENDING: true,
            LIVE: true,
            CANCELLED: false,
            COMPLETED: false
          },
          userId: $scope.userId
        };
      };

      $scope.query = cacheService.getObject($scope.queryKey);
      $scope.sports = await sportService.getSports();

      if ($scope.userId || !$scope.query) {
        $scope.reset()
      }


      $scope.search = function () {
        paginationService.resetPage($scope.pageKey);
        paginationService.pageQuery(getContests, $scope.pageKey);
      };

      var getContests = function () {
        cacheService.registerObject($scope.queryKey, $scope.query)
        return searchService.get("pickems/contests" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
          $scope.contests = response.data.result;
          cacheService.registerObject("contests", $scope.contests);
          paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
        });
      }

      $scope.btnPress = function (keyEvent) {
        if (keyEvent.which === 13)
          $scope.search();
      }

      if ($scope.userId) {
        $scope.search()
      }
    }
  };
});
